import { Button, Card, Heading, Text, ThemeToggle } from "@microbeta/ui";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { MetaTags } from "../../../../shared/components";
import { useAnalytics } from "../../../../shared/hooks";
import { paths } from "../../../../shared/utils/routing";
import { useAuthContext } from "../../AuthContext";
import background from "../../assets/images/background.svg";
import { RecaptchaNotice } from "../../components/RecaptchaNotice";
import { SignInGoogleButton } from "../../components/SignInGoogleButton";
import styles from "./signup.module.scss";

const SignUp = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { signInWithGoogle } = useAuthContext();
  const { trackPageView } = useAnalytics();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get("redirectUrl");
  console.log(`SignUpPage: redirectUrl from params: ${redirectUrl}`);

  useEffect(() => {
    trackPageView("signup_page");
  }, [trackPageView]);

  const handleEmailSignUp = () => {
    navigate(
      redirectUrl
        ? `${paths.signUpWithEmail}?redirectUrl=${redirectUrl}`
        : paths.signUpWithEmail
    );
  };

  return (
    <div className={styles.container}>
      <MetaTags
        title="Join Microbeta - Climbing Community"
        description="Join Microbeta, the premier climbing community platform. Discover climbing areas, track your progress, share beta, and connect with climbers worldwide."
        keywords="sign up, join, climbing community, rock climbing, modeling, climbing areas, climbing beta"
        noIndex={true}
        noFollow={true}
      />
      <img src={background} alt="background" className={styles.backgroundImg} />

      {/* Theme Toggle - positioned in top-right corner */}
      <div className={styles.themeToggleContainer}>
        <ThemeToggle size="md" />
      </div>

      <Card className={styles.card}>
        <Heading variant="medium" className={styles.title}>
          {t("signUp.landingTitle")}
        </Heading>
        <Text variant="large" className={styles.description}>
          {t("signUp.landingSubtitle")}
        </Text>
        <SignInGoogleButton
          className={styles.button}
          onClick={() => signInWithGoogle(redirectUrl ?? undefined)}
        />
        <Button
          variant="primary"
          onClick={handleEmailSignUp}
          className={styles.button}
        >
          {t("signUp.signUpWithEmail")}
        </Button>
        <Text variant="small">
          {t("signUp.alreadyHaveAccount")}
          <Link
            to={
              redirectUrl
                ? `${paths.signin}?redirectUrl=${redirectUrl}`
                : paths.signin
            }
          >
            <Text className={styles.signInLinkText} as="span" variant="small">
              {t("signUp.signInHere")}
            </Text>
          </Link>
        </Text>
        <RecaptchaNotice />
      </Card>
    </div>
  );
};

export default SignUp;
